import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { SeguroService } from '../../_services/seguro.service';
import { Seguro } from '../../_models/seguro';
import { Cuestionario } from '../../_models/cuestionario';
import { forkJoin } from 'rxjs';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ClausuladoService } from '../../_services/clausulado.service';
import { Adjunto } from '../../_models/adjunto';
import { AdjuntoService } from '../../_services/adjunto.service';
import {AppSettings} from '../../../proyect.conf';
import {FileUpload} from 'primeng/fileupload';
import {ConstanteService} from '../../_services/constante.service';
import {PlantillaService} from '../../_services/plantilla.service';
import {Plantilla} from '../../_models/plantilla';
import {QuillEditorComponent} from 'ngx-quill';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import {sleep} from '../../utils/utilidades';
import {Pasos} from '../../_enums/enum';
import {FlujoVentaPasoTiposPersonas} from '../../_models/flujo-venta-paso-tipos-personas';
import {SegurosTiposPersonasService} from '../../_services/seguros-tipos-personas.service';
import {SegurosTiposPersonas} from '../../_models/seguros-tipos-personas';

@Component( {
  selector: 'app-seguro-editar',
  templateUrl: 'seguro-editar.component.html'
} )

export class SeguroEditarComponent implements OnInit {
  @ViewChild( 'adjunto' ) adjunto: FileUpload;
  @ViewChild('cuerpo') cuerpoChild: QuillEditorComponent;
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  seguro: Seguro;
  lisSeguros: Seguro[] = [];
  tabSeleccionado = 'SEGU';
  formulario: FormGroup;
  submitted = false;
  lisCuestionarios: SelectItem[] = [];
  lisCuestionariosTodos: Cuestionario[] = [];
  lisTiposValoresAsegurados: SelectItem[] = [];
  lisTiposValoresAseguradosTodos: ListaItem[] = [];
  mostrarDlgAdjunto = false;
  rutAdjunto: SafeResourceUrl;
  carAdjunto = false;
  imagen: SafeResourceUrl;
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  dataUploadArchivo: any = '';
  dataUploadUsuario: any = '';
  usuarioLogueado: any;
  fsize: number;
  ftype = 'image/svg+xml';
  subAdjunto = false;

  lisPlantilla: SelectItem[] = [];
  lisPlantillaTodos: Plantilla[] = [];
  modQuill = {} as any;
  listasTiposPersonas: SelectItem[] = [];
  listaSegurosTipoPersonas: SegurosTiposPersonas[] = [];
  naturaleza : any[] = [];
  constructor( private serSeguro: SeguroService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private router: Router,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               private serCuestionarios: CuestionarioService,
               private claServicio: ClausuladoService,
               private adjServicio: AdjuntoService,
               private sanitizer: DomSanitizer,
               private conConstanteService: ConstanteService,
               private plantillaService: PlantillaService,
               private listaService: ListaService,
               private segurosTiposPersonas: SegurosTiposPersonasService) {

    this.modQuill = {
      'emoji-shortname': true,
      'emoji-textarea': true,
      'emoji-toolbar': true,
      'toolbar': [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean'],
        ['link'],
        ['emoji']
      ],
      resize: {
        locale: {
          // change them depending on your language
          altTip: "Hold down the alt key to zoom",
          floatLeft: "Left",
          floatRight: "Right",
          center: "Center",
          restore: "Restore",
        },
      }
    };
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined ) {
        this.serSeguro.obtenerPorId( params[ 'id' ] ).subscribe( seguro => {
          this.seguro = seguro;
          if(seguro.idAdjuntoIcono) {
            this.cargarlogoInicial(seguro.idAdjuntoIcono);
          }
          this.carServiciosIniciales();
        } );
      } else {
        this.carServiciosIniciales();
      }
    } );
  }

  carServiciosIniciales() {

    this.usuarioLogueado = this.autServicio.obtenerUsuario();

    forkJoin( this.serSeguro.listado(),
      this.serCuestionarios.listadoConRespuesta(),
      this.conConstanteService.getByCode( 'FSIZE' ),
      this.plantillaService.getAllEnabled(),
      this.listaService.getMasterDetails('ListasTiposValoresAsegurados'),
      this.listaService.getMasterDetails( 'ListasTiposPersonas' ),
      this.cargarSegurosTipoPersonas()
      ).subscribe( ( [ seguros, cuestionarios, tamMaximo ,lisPlantillaTodos, lisTiposValoresAsegurados, listaTiposPersonas, segurosTipoPersona] ) => {
        this.lisSeguros = seguros;
      this.lisCuestionariosTodos = cuestionarios;
      this.lisPlantillaTodos = lisPlantillaTodos;
      this.listasTiposPersonas = listaTiposPersonas.map( s => ( { label: s.nombre, value: s.idLista } ) );
      this.lisTiposValoresAseguradosTodos = lisTiposValoresAsegurados;
      this.lisTiposValoresAseguradosTodos.map((v) => {
        this.lisTiposValoresAsegurados.push( {label: v.nombre, value: v.idLista} );
      });
      this.lisCuestionariosTodos.map( ( s: Cuestionario ) => {
        if ( s.indicadorHabilitado ) {
          this.lisCuestionarios.push( { label: s.nombre, value: s.idCuestionario } );
        }
      } );

      this.lisPlantillaTodos.map( ( s: Plantilla ) => {
        if ( s.indicadorHabilitado ) {
          this.lisPlantilla.push( { label: s.nombre, value: s.idPlantilla } );
        }
      } );
      this.fsize = ( tamMaximo && tamMaximo.valor ) ? Number( tamMaximo.valor ) : 50000000;
      this.cargarFormulario();

      this.verificarValidadores(true);

    } );

  }


  cargarFormulario() {
    this.naturaleza = [];
    this.listaSegurosTipoPersonas.forEach( e => {
      if ( e.indicadorHabilitado ) {
        this.naturaleza.push( e.idTipoPersona );
      }
    } );

    this.formulario = this.fb.group( {
      idSeguro: [ this.seguro ? this.seguro.idSeguro : null ],
      codigo: [ this.seguro ? this.seguro.codigo : null, [ Validators.required ] ],
      nombre: [ this.seguro ? this.seguro.nombre : null, [ Validators.required ] ],
      indicadorTasa: [ this.seguro ? this.seguro.indicadorTasa : true, [ Validators.required ] ],
      idValorAsegurado: [this.seguro ? this.seguro.idValorAsegurado: null],
      valorTasa: [ this.seguro ? this.seguro.valorTasa : null ],
      polizaMaestra: [ this.seguro ? this.seguro.polizaMaestra : null, [ Validators.required ] ],
      descripcion: [ this.seguro ? this.seguro.descripcion : null ],
      descripcionCobertura: [ this.seguro ? this.seguro.descripcionCobertura : null ],
      indicadorBeneficiarios: [ this.seguro ? this.seguro.indicadorBeneficiarios : false, [ Validators.required ] ],
      indicadorDeclaracionRiesgo: [ this.seguro ? this.seguro.indicadorDeclaracionRiesgo : false, [ Validators.required ] ],
      idCuestionario: [ this.seguro ? this.seguro.idCuestionario : null ],
      indicadorAseguraNegocio: [ this.seguro ? this.seguro.indicadorAseguraNegocio : false, [ Validators.required ] ],
      indicadorAseguraHogar: [ this.seguro ? this.seguro.indicadorAseguraHogar : false, [ Validators.required ] ],
      indicadorAseguraContenidoHogar: [ this.seguro ? this.seguro.indicadorAseguraContenidoHogar : false, [ Validators.required ] ],
      indicadorAseguraContenidoNegocio: [ this.seguro ? this.seguro.indicadorAseguraContenidoNegocio : false, [ Validators.required ] ],
      indicadorRequiereImc:      [this.seguro?.indicadorRequiereImc      ?? false],
      indicadorBeneficiariosLey: [this.seguro?.indicadorBeneficiariosLey ?? false],
      indicadorHabilitado: [ this.seguro ? this.seguro.indicadorHabilitado : false, [ Validators.required ] ],
      idAdjuntoIcono: [ this.seguro ? this.seguro.idAdjuntoIcono : null ],
      nombreArchivo: [ this.seguro ? this.seguro.nombreAdjuntoIcono : null ],
      idPlantillaDigital: [ this.seguro ? this.seguro.idPlantillaDigital : null , [ Validators.required ] ],
      descripcionBilletera:  [ this.seguro ? this.seguro.descripcionBilletera : null ],
      descripcionCoberturaBilletera:  [ this.seguro ? this.seguro.descripcionCoberturaBilletera : null ],
      naturaleza: [ this.naturaleza, [ Validators.required ] ],
    } );

    this.setearElementosHTMLIniciales(this.seguro);
  }
  async cargarSegurosTipoPersonas() {
    if (!this.seguro) {
      return;
    }
    this.listaSegurosTipoPersonas = await this.segurosTiposPersonas.listadoPorIdSeguro(this.seguro.idSeguro).toPromise();

  }
  async setearElementosHTMLIniciales(item: any){
    await sleep(10);
    if (this.cuerpoChild && this.cuerpoChild.quillEditor && this.cuerpoChild.quillEditor.root) {
      this.cuerpoChild.quillEditor.root.innerHTML = item.descripcion;
    }
  }

  verificarValidadores(cargaInicial = false) {

    const valorTasaCtrl = this.f.valorTasa;
    const idValorAseguradoCtrl = this.f.idValorAsegurado;
    const idCuestionarioCtrl = this.f.idCuestionario;

    if ( this.f.indicadorTasa.value ) {
      this.f.valorTasa.setValidators( [ Validators.required ] );
      this.f.idValorAsegurado.setValidators( [ Validators.required ] );
    } else {
      this.f.valorTasa.setValidators( [] );
      this.f.valorTasa.setValue( null );
      this.f.idValorAsegurado.setValidators( [] );
      this.f.idValorAsegurado.setValue( null );
    }

    valorTasaCtrl.updateValueAndValidity();
    idValorAseguradoCtrl.updateValueAndValidity();

    if ( this.f.indicadorDeclaracionRiesgo.value ) {
      this.f.idCuestionario.setValidators( [ Validators.required ] );
    } else {
      this.f.idCuestionario.setValidators( [] );
      this.f.idCuestionario.setValue( null );
    }
    idCuestionarioCtrl.updateValueAndValidity();
    if (cargaInicial) {
      this.carInformacionInicial = false;
    }
  }

  setearEditarCenter(objeto: any ) {
    if(this.cuerpoChild && this.cuerpoChild.quillEditor && this.cuerpoChild.quillEditor.root){
      objeto.cuerpoPregunta = this.cuerpoChild.quillEditor.root.innerHTML;
    }
  }

 async  onSubmit() {
    this.submitted = true;

    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      this.setearEditarCenter(formulario);
      if ( formulario.idSeguro ) {
        /** Actualizar seguro */
        this.verificarValidadores();
        this.serSeguro.actualizar( formulario ).subscribe( seguroActualizado => {
          this.seguro = seguroActualizado;
          this.validarTipoPersona(formulario);
          this.guardando = false;
          this.submitted = false;
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'SEGURO.MSG_ACTUALIZO' )
          } );
          setTimeout(() => {
            if ( !this.seguro.indicadorTasa ) {
              this.cambiarTabSeleccionado( 'PLAN' );
            } else {
              this.router.navigate( [ 'apl/seguro/' ] );
            }
          });
        } );
      } else {
        /** Crea seguro */
        this.verificarValidadores();
        this.serSeguro.crear( formulario ).subscribe( seguroNuevo => {
          this.seguro = seguroNuevo;
          this.f.idSeguro.setValue( this.seguro.idSeguro );
          this.validarTipoPersona(formulario);
          this.guardando = false;
          this.submitted = false;
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'SEGURO.MSG_CREO' )
          } );
          setTimeout(() => {
            if ( !this.seguro.indicadorTasa ) {
              this.cambiarTabSeleccionado( 'PLAN' );
            } else {
              this.router.navigate( [ 'apl/seguro/' ] );
            }
          });

        } );
      }

    } else if ( this.codExiste ) {
      this.navServicio.setMesage( 0, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'SEGURO.MSG_ERRORCOD' )
      } );
    }
  }

  async validarTipoPersona( form: any ) {
    const lista = [];
    form.naturaleza.forEach( e => {
      const _data = this.listaSegurosTipoPersonas.find( x => x.idTipoPersona === e );
      if ( _data && !_data.indicadorHabilitado ) {
        _data.indicadorHabilitado = true;
        lista.push( _data );
      } else {
        if (!_data) {
          const a = {} as SegurosTiposPersonas;
          a.idTipoPersona = e;
          a.indicadorHabilitado = true;
          a.idSeguro = this.seguro.idSeguro;
          lista.push( a );
        }

      }
    } );

    this.listaSegurosTipoPersonas.forEach( e => {
      if ( e.indicadorHabilitado && !form.naturaleza.find( y => y === e.idTipoPersona ) ) {
        e.indicadorHabilitado = false;
        lista.push( e );
      }
    } );

    if ( lista.length > 0 ) {
      const resultado = await this.segurosTiposPersonas.bulk( lista ).toPromise();
      resultado.forEach( e => {
        const existe = this.listaSegurosTipoPersonas.find( x => x.idTipoPersona === e.idTipoPersona );
        if ( !existe ) {
          this.listaSegurosTipoPersonas.push( e );
        }
      } );
    }
    return true;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisSeguros.find( x => x.codigo === this.f.codigo.value && x.idSeguro !== this.f.idSeguro.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }



  cambiarTabSeleccionado(tab: string) {
    const tabs = this.obtenerTabsVisibles();
    if (tabs.includes(tab)) {
      this.tabSeleccionado = tab;
    } else {
      this.tabSeleccionado = 'SEGU';
    }
  }

  /**Cambia check asegura inmubles y asegura contenidos para que no se crucen las validaciones*/
  cambioCheckAseguraInmueble( check: string ) {
    switch ( check ) {
      case 'aseguraNegocio':
        if ( this.f.indicadorAseguraNegocio.value ) {
          this.f.indicadorAseguraContenidoHogar.setValue( false );
          this.f.indicadorAseguraContenidoNegocio.setValue( false );
        }
        break;
      case 'aseguraHogar':
        if ( this.f.indicadorAseguraHogar.value ) {
          this.f.indicadorAseguraContenidoHogar.setValue( false );
          this.f.indicadorAseguraContenidoNegocio.setValue( false );
        }
        break;

      case 'aseguraContenidoNegocio':
        if ( this.f.indicadorAseguraContenidoNegocio.value ) {
          this.f.indicadorAseguraHogar.setValue( false );
          this.f.indicadorAseguraNegocio.setValue( false );
        }
        break;
      case 'aseguraContenidoHogar':
        if ( this.f.indicadorAseguraContenidoHogar.value ) {
          this.f.indicadorAseguraHogar.setValue( false );
          this.f.indicadorAseguraNegocio.setValue( false );
        }
        break;
    }
  }

  verAdjunto() {
    this.carAdjunto = true;
    this.rutAdjunto = null;
    this.claServicio.obtenerIdentificadorAlfresco( this.f.codigo.value ).subscribe( alfresco => {
      if ( alfresco && alfresco.idAlfresco ) {
        this.adjServicio.obtenerPorIdAlfresco( alfresco.idAlfresco ).subscribe( adjunto => {
          const blob = URL.createObjectURL( adjunto );
          this.rutAdjunto = this.sanitizer.bypassSecurityTrustResourceUrl( blob );
          this.mostrarDlgAdjunto = true;
          this.carAdjunto = false;
        }, error => {
          this.navServicio.setMesage( 3 );
          this.carAdjunto = false;
        } );
      } else {
        this.mostrarDlgAdjunto = true;
        this.carAdjunto = false;
      }
    }, error => {
      this.navServicio.setMesage( 3 );
      this.carAdjunto = false;
    } );
  }

  cerrar() {
    this.mostrarDlgAdjunto = false;
  }

  cargarlogoInicial(idAdjunto) {
    this.subAdjunto = true;
    this.adjServicio.descargarArchivo( idAdjunto ).subscribe( adjunto => {
      const reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
      }, false );
      if ( adjunto ) {
        reader.readAsDataURL( adjunto );
      }
      this.subAdjunto = false;
    });
  }

  uploadAgain( rta: boolean ) {
    this.seguro.idAdjuntoIcono = null;
    this.seguro.nombreAdjuntoIcono = null;
    this.f.idAdjuntoIcono.setValue( null );
    this.f.nombreArchivo.setValue( null );
  }

  onBeforeSend( event: any ) {
    this.subAdjunto = true;
    this.adjServicio.cargarArchivo( event, this.dataUploadArchivo, '/Crezcamos/Producto/Referencias' );
  }

  onSelect( event: any, file: any ) {
    if (this.adjunto.msgs.length === 0) {
      this.dataUploadArchivo = file[ 0 ].name;
      this.dataUploadUsuario = this.usuarioLogueado.idUsuario;
      this.f.nombreArchivo.setValue( file[ 0 ].name );
      const reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
      }, false );
      if ( file[ 0 ] ) {
        reader.readAsDataURL( file[ 0 ] );
      }
    } else {
      this.navServicio.setMesageArray( this.adjunto.msgs );
    }

  }

  uploadingOk( event: any ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto != null || respuesta.idAdjunto !== undefined ) {
      this.f.idAdjuntoIcono.setValue( respuesta.idAdjunto );
      this.cargarlogoInicial(respuesta.idAdjunto);
      console.log(this.seguro);
      this.subAdjunto = false;
    }
  }

  eliminarAdjunto() {
    this.f.idAdjuntoIcono.setValue(null);
    this.f.nombreArchivo.setValue(null);
  }



  onTabChange(event: any) {
    const tabs = this.obtenerTabsVisibles();
    this.tabSeleccionado = tabs[event.index] ?? 'SEGU';
  }


  get indiceActivo(): number {
    const tabs = this.obtenerTabsVisibles();
    const indice = tabs.indexOf(this.tabSeleccionado);
    return indice >= 0 ? indice : 0;
  }

  private obtenerTabsVisibles(): string[] {
    const tabs: string[] = ['SEGU'];

    if (this.seguro && !this.seguro.indicadorTasa) {
      tabs.push('PLAN');
    }


    if (this.seguro) {
      tabs.push('COBE');
    }

    if (this.seguro && (
      this.seguro.indicadorAseguraHogar ||
      this.seguro.indicadorAseguraNegocio ||
      this.seguro.indicadorAseguraContenidoHogar ||
      this.seguro.indicadorAseguraContenidoNegocio
    )) {
      tabs.push('BIENES');
    }

    return tabs;
  }


}
